
import React, { useState } from 'react';
import './documentationPage.css';
import NavigationMenu from './../navigationMenu/navigationMenu';
import Purse from './../purse/purse';
import ButtonVariant from './../buttonVariant/buttonVariant';
import { Link } from 'react-router-dom';
import Document from './../document/document';
import ButtonIcon from './../buttonIcon/buttonIcon';
import CopiIcon from '../../img/Copy.png';
import Code from './../code/code';
import Warning from './../warning/warning';
import WarningIcon from '../../img/WarningCircle.png';
import ColumContainer from './../columContainer/columContainer';
import Column from './../column/column';
import Border from './../border/border';
import Corzina from '../../img/image 26.png';
import PRESTASHOP from '../../img/image 27.png';
import Wordpress from '../../img/image 29.png';
import BOXEXCHANGER from '../../img/image 28.png';


const DocumentationPage = () => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>
      <div>
        <NavigationMenu >
          <Purse title="Магазины">
            <div className="content_navigatino">
              <Link to="/SaveStores">
                <div >
                  <ButtonVariant name="Все магазины" isShow={true} />
                </div>
              </Link>
              <Link to="/DocumentationPage">
                <div >
                  <ButtonVariant name="Документация" />
                </div>
              </Link>
            </div>
            <div className="documetacion_text">
              Documentation for integration with online stores, Forex, trading platforms, Etc. examples of implementation are available for popular programming languages: PHP, Python, C#, Node.JS. We hope that the implementation will be simple and clear.
            </div>
            <ColumContainer title="1. Ready-made modules" isRow={true}>
              <Border title="OPENCART" src={Corzina} text="OpenCart 3.0.2.0" />
              <Border title="PRESTASHOP" src={PRESTASHOP} text="PrestaShop 1.7" />
              <Border title="WORDPRESS" src={Wordpress} text="4.0 Woocommerce Premium Exchanger 1.6" />
              <Border title="BOXEXCHANGER" src={BOXEXCHANGER} text="BoxExchanger v2.0.*" />
            </ColumContainer>
            <Document name="" title="2. Manual setting of the merchant" >
              <Code text="<?php " />
              <Code text="$merchantId = ''; " />
              <Code text="$orderId = '1';" />
              <Code text="$amount = number_format(100, 2, '.', '');" />
              <Code text="$currency = 'USD';" />
              <Code text="$desc = 'USD';" />
              <Code text="$secretKey = 'YOUR_SECRET';" />
              <Code text="$arHash = array(" />
              <Code text="$merchantId," />
              <Code text="$orderId," />
              <Code text="$amount," />
              <Code text="$currency," />
              <Code text="$secretKey" />
              <Code text=");" />
              <Code text="$sign = strtoupper(hash('sha256', implode(':', $arHash)));" />
              <Code text="?>" />
              <Code text='<input type="hidden" name="merchantId" value="<?=$merchantId?>">' />
              <Code text='<input type="hidden" name="orderId" value="<?=$orderId?>">' />
              <Code text='<input type="hidden" name="amount" value="<?=$amount?>">' />
              <Code text='<input type="hidden" name="currency" value="<?=$currency?>">' />
              <Code text='<input type="hidden" name="hash" value="<?=$sign?>">' />
              <Code text='<input type="hidden" name="description" value="<?=$desc?>">' />
              <Code text='<input type="submit" />' />
              <Code text="</form>" />
            </Document>
            <div className="max-width_btn">
              <ButtonIcon name="Copy" src={CopiIcon} />
            </div>
            <Document nam2="UTF-8" nam3="To go to the payment page you need to create the following form:" name="The file encoding must be " title="2.1. Payment Initialization Form" >
              <Code text='<input type="hidden" name="merchantId" value="<?=$merchantId?>">' />
              <Code text='<input type="hidden" name="orderId" value="<?=$orderId?>">' />
              <Code text='<input type="hidden" name="amount" value="<?=$amount?>">' />
              <Code text='<input type="hidden" name="currency" value="<?=$currency?>">' />
              <Code text='<input type="hidden" name="hash" value="<?=$sign?>">' />
              <Code text='<input type="hidden" name="description" value="<?=$desc?>">' />
              <Code text='<input type="submit" />' />
              <Code text="</form>" />
            </Document>
            <div className="max-width_btn">
              <ButtonIcon name="Copy" src={CopiIcon} />
            </div>
            <ColumContainer title="2.2. Form parameters">
              <Column text1="merchant URL" text2="action" text3="merchant URL" isBack={false} />
              <Column text1="merchant ID" text2="merchantId" text3="merchant ID registered in system to which the payment will be made your merchant ID" isBack={true} />
              <Column text1="payment ID" text2="orderId" text3='in this field, the seller sets the purchase ID according to their accounting system. It is advisable to use a unique number for each payment.
the Identifier must be any string of length more than 32 characters from the characters "A-z", "_", "0-9".
Example: 12345' isBack={false} />
              <Column text1="payment Amount" text2="amount" text3="the amount of payment the seller wishes to receive from the buyer. The sum must be greater than zero, the fractional part is separated by a point, the number of characters after the point - two characters.
Example: 1.00" isBack={true} />
              <Column text1="payment currency	" text2="currency" text3="payment Currency
Possible currencies: USD, BTC" isBack={false} />
            </ColumContainer>
            <Document title="2.3. Digital signature generation (PHP)" >
              <Code text="<?php " />
              <Code text="$arHash = array(" />
              <Code text="$merchantId," />
              <Code text="$paymentId," />
              <Code text="$orderId," />
              <Code text="$amount," />
              <Code text="$billAmount," />
              <Code text="$currency," />
              <Code text="$billCurrency," />
              <Code text="$datatime," />
              <Code text="$status," />
              <Code text="$secret_key" />
              <Code text=");" />
              $sign = strtoupper(hash('sha256', implode(":", $arHash)));
              <Code text="<?php" />
              <Code text="?>" />
            </Document>
            $secret_key - secret key from merchant settings
            <div className="max-width_btn">
              <ButtonIcon name="Copy" src={CopiIcon} />
            </div>
            <Document name="$secret_key - secret key from merchant settings" nam2="Payment processor must be located at the address specified in the merchant’s settings in the Status URL field Your Status URL:" title="2.4. Payment Processor Example (PHP)" >
              <Code text="<?php" />
              <Code text="if (isset($_POST['orderId']) && isset($_POST['hash']))" />
              <Code text="{" />
              <Code text="$secret_key = 'YOUR SECRET KEY';" />
              <Code text="$arHash = array(" />
              <Code text="$_POST['merchantId']," />
              <Code text="$_POST['paymentId']," />
              <Code text="$_POST['orderId']," />
              <Code text="$_POST['amount']," />
              <Code text="$_POST['billAmount']," />
              <Code text="$_POST['currency']," />
              <Code text="$_POST['billCurrency']," />
              <Code text="$_POST['datatime']," />
              <Code text="$_POST['status']" />
              <Code text="?>" />
              <Code text=");" />
              <Code text="$arHash[] = $secret_key;" />
              <Code text="$sign_hash = strtoupper(hash('sha256', implode(':', $arHash)));" />
              <Code text="if ($_POST['hash'] == $sign_hash && $_POST['status'] == 'success')" />
              <Code text="{" />
              <Code text="echo 'ok';" />
              <Code text="exit;" />
              <Code text="}" />
              <Code text="echo 'error';" />
              <Code text="}" />
              <Code text="?>" />
            </Document>
            <Warning text="ok" src={WarningIcon} />
            <div>The payment processor must return a text ok or error as shown in the example above</div>
            <Warning text="SOON SHOW IP For the security of receiving requests from our site, be sure to install IP verification. sender address." src={WarningIcon} />
            <div className="max-width_btn">
              <ButtonIcon name="Copy" src={CopiIcon} />
            </div>
            <ColumContainer title="2.5. Deciphering payment handler options">
              <Column text1="Id shop	" text2="merchantId" text3="Id shop
Example: 5be9bb1bc5032a10b28b9589" isBack={false} />
              <Column text1="Internal payment number	" text2="paymentId" text3="Payment number in the system, executed during the processing of a request for payment by Merchant service. It is unique in the system.
Example: 5be9bb1bc5032a10b28b9589" isBack={true} />
              <Column text1="Order ID	" text2="orderId" text3='In this field, the seller sets the purchase ID in accordance with their system. accounting. It is advisable to use a unique number for each payment.
Identifier must be any string no longer than 32 characters from characters: "A-z", "_", "0-9".
Example: 12345' isBack={false} />
              <Column text1="Amount of payment	" text2="amount" text3="tThe amount of payment that the seller wishes to receive from the buyer. The amount must be greater than zero, the fractional part is separated by a point.
Example: 1.00" isBack={true} />
              <Column text1="Amount of order	" text2="billAmount" text3="The amount of payment that the seller wishes to receive from the buyer. The amount must be greater than zero, the fractional part is separated by a point.
The amount of payment that the seller wishes to receive from the buyer. The amount must be greater than zero, the fractional part is separated by a point.
Example: 1.00: 1.00" isBack={false} />
              <Column text1="Currency of payment		" text2="currency" text3="Currency of payment
Possible currencies: USD, BTC" isBack={true} />
              <Column text1="Currency of order	" text2="billCurrency" text3='Currency of order)
Possible currencies: USD, BTC' isBack={false} />
              <Column text1="Date of send ipn	" text2="datatime" text3="Date and time of formation of the operation in unix format
Example: 123456789" isBack={true} />
              <Column text1="Payment Status	" text2="status" text3="Payment status in the system
Accepted values: success, fail" isBack={false} />
              <Column text1="Electronic signature	" text2="hash" text3="Control signature, which is used to verify the integrity of the received information and unique identification of the sender
Example:h55dsaGG" isBack={true} />
            </ColumContainer>
            <div className="container_margin"></div>
          </Purse>
        </NavigationMenu>
      </div>
    </>

  )
}

export default DocumentationPage;